import { CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { ApiV1Service } from 'api';

export const ManufacturerExistsGuard: CanActivateFn = async (_route, _state) => {
  const apiService = inject(ApiV1Service);
  const router = inject(Router);

  try {
    await firstValueFrom(apiService.getCurrentManufacturer());
  } catch (err) {
    return new RedirectCommand(router.parseUrl('/manufacturer'));
  }

  return true;
};
